import { useB2BInternals } from './useB2BInternals.mjs';

const useNetworkClient = ()=>{
    const { networkClient } = useB2BInternals();
    return networkClient;
};

export { useNetworkClient };
//# sourceMappingURL=useApiNetworkClient.mjs.map
